import { render, staticRenderFns } from "./modalAddEventAttendee.vue?vue&type=template&id=6720c820&scoped=true&"
import script from "./modalAddEventAttendee.vue?vue&type=script&lang=js&"
export * from "./modalAddEventAttendee.vue?vue&type=script&lang=js&"
import style0 from "./modalAddEventAttendee.vue?vue&type=style&index=0&id=6720c820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720c820",
  null
  
)

export default component.exports